/**
 * Marketo API reference: https://developers.marketo.com/rest-api/assets/forms/examples/
 */

/**
 * @param marketoId {string}
 * @return {Promise<LoadMarketoFormPromisePayload>}
 * @throws {Error} - Marketo is not loaded
 */
module.exports = async function loadMarketoForm(marketoId) {
    // The extra variable is needed for IntelliJ's type-hinting to work!
    // Please don't remove it!

    /**
     * @type {Promise<LoadMarketoFormPromisePayload>}
     */
    const promise = new Promise((resolve, reject) => {
        if ("MktoForms2" in window && "loadForm" in window.MktoForms2) {
            const marketoFormContainer = document.createElement("div");
            marketoFormContainer.style.display = "none";
            marketoFormContainer.innerHTML = `<form id="mktoForm_${marketoId}"></form>`;
            document.body.append(marketoFormContainer);

            window.MktoForms2.loadForm('https://go.iterable.com', "723-YAV-537", marketoId, function(marketoForm) {
                const data = {marketoForm, marketoFormContainer};
                resolve(data);
            });
        } else {
            reject(new Error("Marketo is not loaded"));
        }
    });

    return promise;
}